import { Button, Text } from '@/ui'
import { TypographyStyles, TextColors, mtc } from '@/styles'
import { ONBOARDING_SCREEN } from './onboardingScreen.styles'

/**
 * A load that failed, as an end state rather than as more waiting.
 *
 * Without it the screens sit on their in-progress copy indefinitely, because the thing they
 * wait on is a status the failed request never advances.
 */
export const SeparationLoadError = ({
  onRetry,
  onBack,
  onSkip,
}: {
  onRetry: () => void
  onBack?: () => void
  onSkip: () => void
}) => (
  <div className={ONBOARDING_SCREEN.page}>
    <div
      className={mtc(
        ONBOARDING_SCREEN.content,
        'flex-1 justify-center text-center'
      )}
    >
      <div
        className={mtc(
          ONBOARDING_SCREEN.header,
          ONBOARDING_SCREEN.narrowColumn
        )}
      >
        <Text variant={TypographyStyles.DISPLAY_SM} textAlign="center">
          We couldn&apos;t load your transactions
        </Text>
        <Text
          variant={TypographyStyles.BODY_SM}
          color={TextColors.MUTED}
          textAlign="center"
        >
          Nothing is lost. Try again, and if it keeps happening your bookkeeping
          team can sort these without you.
        </Text>
      </div>
      <div className="flex flex-col gap-2">
        <Button variant="primary" onClick={onRetry}>
          Try again
        </Button>
        {onBack && (
          <Button variant="secondary" onClick={onBack}>
            Back
          </Button>
        )}
        <Button variant="secondary" onClick={onSkip}>
          Skip to dashboard
        </Button>
      </div>
    </div>
  </div>
)
